import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WhoAreWe from './pages/WhoAreWe';
import FAQ from './pages/FAQ';
import MeetTheTutors from './pages/MeetTheTutors';
import TutorLogin from './pages/TutorLogin'; // Updated import
import UpdateAvailability from './pages/UpdateAvailability'; // Import UpdateAvailability component
import BookingPage from './pages/BookingPage';
import 'bootstrap/dist/css/bootstrap.min.css';

const MainContent = styled.main`
  padding-top: 5rem;
`;

function App() {
  const [token, setToken] = useState(null);

  return (
    <>
      <Navbar />
      <MainContent>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/who-are-we" element={<WhoAreWe />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/meet-the-tutors" element={<MeetTheTutors />} />
          <Route path="/tutor-login" element={<TutorLogin setToken={setToken} />} /> {/* Pass setToken as a prop */}
          <Route path="/update-availability" element={<UpdateAvailability token={token} />} /> {/* Use token for UpdateAvailability */}
          <Route path="/book-session" element={<BookingPage />} /> {/* Ensure this route exists */}
        </Routes>
      </MainContent>
      <Footer />
    </>
  );
}

export default App;